(function () {
  function startGopshopBenefits() {
    const section = document.querySelector(
      '#shopify-block-AVW5TSkwrZHY3aXJRT__sternify_benefit_four_boxes_v2_m6Dmbz'
    );

    if (!section) return;

    const cards = section.querySelectorAll(
      '.st_cashout-prdouctinfo-box'
    );

    const language =
      (document.documentElement.lang || 'en')
        .toLowerCase()
        .split('-')[0];

    const details = {
      de: [
        'Versand mit Tracking. Wir koordinieren die internationale Abwicklung persönlich bis zur Zustellung.',
        'Geeignet für Wiederverkauf, Großhandel und Dropshipping – individuell auf dein Vorhaben abgestimmt.',
        'Sorgfältig ausgewählte Produkte mit Fokus auf hochwertige Verarbeitung und zuverlässige Qualität.',
        'Persönliche Betreuung über unser Partnernetzwerk – von der Anfrage bis zur Bestellabwicklung.'
      ],
      en: [
        'Tracked shipping with personal coordination throughout the international delivery process.',
        'Suitable for reselling, wholesale and dropshipping – individually tailored to your project.',
        'Carefully selected products with a focus on premium workmanship and reliable quality.',
        'Personal support through our partner network – from your request to order processing.'
      ],
      fr: [
        'Expédition avec suivi et coordination personnelle tout au long du processus international.',
        'Adapté à la revente, au commerce de gros et au dropshipping selon votre projet.',
        'Produits soigneusement sélectionnés avec une finition premium et une qualité fiable.',
        'Accompagnement personnel via notre réseau de partenaires, de la demande au traitement.'
      ]
    };

    const texts = details[language] || details.en;

    cards.forEach(function (card, index) {
      if (card.dataset.gopshopReady === 'true') return;

      card.dataset.gopshopReady = 'true';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-expanded', 'false');

      const textArea = card.querySelector(
        '.st_cashout-prdouctinfo-box-text'
      );

      if (textArea && !textArea.querySelector('.gopshop-extra-detail')) {
        const extraDetail = document.createElement('p');
        extraDetail.className = 'gopshop-extra-detail';
        extraDetail.textContent = texts[index] || '';
        textArea.appendChild(extraDetail);
      }

      function toggleCard() {
        const shouldOpen = !card.classList.contains('is-open');

        cards.forEach(function (otherCard) {
          otherCard.classList.remove('is-open');
          otherCard.setAttribute('aria-expanded', 'false');
        });

        if (shouldOpen) {
          card.classList.add('is-open');
          card.setAttribute('aria-expanded', 'true');
        }
      }

      card.addEventListener('click', toggleCard);

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleCard();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startGopshopBenefits
    );
  } else {
    startGopshopBenefits();
  }

  document.addEventListener(
    'shopify:section:load',
    startGopshopBenefits
  );
})();